<template>
  <div
      v-loading="loading"
      class="order-return-review-customer-details flex flex-auto flex-col">
    <div class="title">
      One-off has been created.
    </div>
    <br><br>
    <div class="description">
      one-off has been generated and sent to the customer. Once the <br>device(s) are dispatched by Ring, the customer will be notified of the<br> tracking information via email.
    </div><br>
    <div class="return-customer-details">
      <el-card shadow="never">
        <div class="flex flex-col">
          <div
              class="summary-header">
            One-off summary
          </div><br>
        </div>
        <div class="flex flex-col">
          <div
              class="summary-header">
            Created On: {{ createdOn }}
          </div>
          <br>
        </div>
        <div class="flex flex-col">
          <div
              class="summary-header">
            Item
          </div>
          <div style="margin-top: 8px;">
            {{ device.product.description }}<br>
            <p style="color: #6E6E6E; margin: 0 !important;">
              ASIN: {{ device.sku }}
            </p>
            <p
                v-if="device.estimated_delivery"
                class="estimated-delivery"
                style="margin: 0 !important;">
              {{ device.estimated_delivery }}
            </p>
          </div>
        </div>
        <el-divider />
        <div class="flex flex-col">
          <div
              class="summary-header">
            Customer info
          </div><br>
        </div>
        <div class="flex flex-col">
          <div class="flex flex-row">
            <div class="flex-1">
              Name
            </div>
            <div>{{ customer.first_name }} {{ customer.last_name }}</div>
          </div>
          <div class="flex flex-row">
            <div class="flex-1">
              Phone Number
            </div>
            <div>{{ customer.phone_number }}</div>
          </div>
          <div class="flex flex-row">
            <div class="flex-1">
              Email
            </div>
            <div>{{ customer.email }}</div>
          </div>
          <el-divider />
          <div
              class="flex flex-row"
              style="margin-top: 20px">
            <div class="flex-1">
              Street
            </div>
            <div>{{ address.address1 }} {{ address.address2 }}</div>
          </div>
          <div
              class="flex flex-row">
            <div class="flex-1">
              City
            </div>
            <div>{{ address.city }}</div>
          </div>
          <div
              class="flex flex-row">
            <div class="flex-1">
              State/province/area
            </div>
            <div>{{ address.state }}</div>
          </div>
          <div
              class="flex flex-row">
            <div class="flex-1">
              Zip code
            </div>
            <div>{{ address.zip_code }}</div>
          </div>
          <div
              class="flex flex-row">
            <div class="flex-1">
              Country
            </div>
            <div>{{ address.country }}</div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
export default {
  name: "OneOffSummary",
  props: {
    createdOn: {
      type: String,
      required: true,
    },
    device: {
      type: Object,
      required: true,
    },
    customer: {
      type: Object,
      required: true,
      default() {
        return {
          first_name: "",
          last_name: "",
          phone_number: "",
          email: "",
        };
      },
    },
    address: {
      type: Object,
      required: true,
      default() {
        return {
          address1: "",
          address2: "",
          city: "",
          state: "",
          zip_code: "",
          country: "",
        };
      },
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    this.loading = false;
  },
  methods: {},
};
</script>

<style>
.order-return-review-customer-details {
  gap: 8px;

  .title {
    height: 36px;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    display: flex;
    align-items: flex-end;
    color: #424242;
    flex: none;
    align-self: stretch;
    flex-grow: 0;
  }

  .description {
    height: 24px;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: flex-end;
    color: #424242;
    flex: none;
    align-self: stretch;
    flex-grow: 0;
  }

  .section-header {
    height: 24px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    align-items: flex-end;
    color: #6e6e6e;
    flex: none;
    flex-grow: 1;
  }

  .return-customer-details {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #424242;
  }
}

.summary-header {
  width: 939px;
  height: 24px;

  /* body/large-medium */

  font-family: "Equip";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: flex-end;

  /* 🖥 light/content/base */

  color: #424242;

  /* Inside auto layout */

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}
</style>
